import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

import * as React from "react";
import styled from "../../styled-components";
import { OperationBadge } from "@redocly/reference-docs";

var externalIconDark = require("../../../images/external-link-dark.svg");

export var ExternalIcon = styled.i(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  vertical-align: middle;\n  background: url(", ");\n  width: 10px;\n  height: 10px;\n  background-repeat: no-repeat;\n  margin-left: 5px;\n"])), externalIconDark);
export var Separator = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  margin-left: ", "px;\n  padding: ", "px\n    ", "px;\n\n  padding-left: ", "px;\n  position: relative;\n  cursor: default;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n\n  &:empty {\n    padding: 0.1em 0;\n  }\n"])), function (_ref) {
  var a = _ref.theme,
      _ref$depth = _ref.depth,
      b = _ref$depth === void 0 ? 0 : _ref$depth;
  return a.sidebar.spacing.offsetLeft + b * a.sidebar.spacing.offsetNesting;
}, function (_ref2) {
  var a = _ref2.theme;
  return a.sidebar.spacing.paddingVertical;
}, function (_ref3) {
  var a = _ref3.theme;
  return a.sidebar.spacing.paddingHorizontal;
}, function (_ref4) {
  var a = _ref4.theme;
  return a.sidebar.spacing.paddingHorizontal + 1.5 * a.sidebar.spacing.unit;
}, function (_ref5) {
  var a = _ref5.theme;
  return a.sidebar.fontFamily;
}, function (_ref6) {
  var a = _ref6.theme;
  return a.sidebar.fontSize;
}, function (_ref7) {
  var a = _ref7.theme;
  return a.typography.fontWeightBold;
}, function (_ref8) {
  var a = _ref8.theme;
  return a.sidebar.separatorLabelColor;
});
export var SeparatorLine = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  display: block;\n  width: 100%;\n  height: 1px;\n  background-color: ", ";\n  margin: ", "px 0;\n"])), function (_ref9) {
  var a = _ref9.theme;
  return a.sidebar.separatorLineColor;
}, function (_ref10) {
  var a = _ref10.theme;
  return a.sidebar.spacing.paddingVertical;
});
export var MenuItemTitle = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n\n  color: ", ";\n  background-color: ", ";\n\n  cursor: ", ";\n\n  margin-left: ", ";\n\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-bottom: ", "px;\n  margin-bottom: 1px; // hardcoded for now\n\n  padding-left: ", "px;\n\n  transition: background-color 0.3s, color 0.3s;\n  border-top-left-radius: ", ";\n  border-bottom-left-radius: ", ";\n\n  word-break: break-word;\n\n  :hover {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  :empty {\n    padding: 0;\n  }\n\n  ", "\n"])), function (_ref11) {
  var a = _ref11.theme;
  return a.sidebar.fontFamily;
}, function (_ref12) {
  var a = _ref12.theme;
  return a.sidebar.fontSize;
}, function (_ref13) {
  var a = _ref13.theme;
  return a.typography.fontWeightRegular;
}, function (a) {
  return a.active ? a.theme.sidebar.activeTextColor : "inherit";
}, function (a) {
  return a.active ? a.theme.sidebar.activeBgColor : "inherit";
}, function (_ref14) {
  var a = _ref14.isAlwaysExpanded;
  return a ? "default" : "pointer";
}, function (_ref15) {
  var a = _ref15.depth,
      b = _ref15.theme;
  return b.sidebar.spacing.offsetLeft + a * b.sidebar.spacing.offsetNesting + "px";
}, function (_ref16) {
  var a = _ref16.theme;
  return a.sidebar.spacing.paddingVertical;
}, function (_ref17) {
  var a = _ref17.theme;
  return a.sidebar.spacing.paddingHorizontal;
}, function (_ref18) {
  var a = _ref18.theme;
  return a.sidebar.spacing.paddingVertical;
}, function (_ref19) {
  var a = _ref19.theme,
      b = _ref19.hasChildren,
      c = _ref19.isAlwaysExpanded;
  return b && !c ? a.sidebar.spacing.paddingHorizontal : a.sidebar.spacing.paddingHorizontal + a.sidebar.caretSize + .5 * a.sidebar.spacing.unit;
}, function (_ref20) {
  var a = _ref20.theme;
  return a.sidebar.borderRadius;
}, function (_ref21) {
  var a = _ref21.theme;
  return a.sidebar.borderRadius;
}, function (_ref22) {
  var a = _ref22.isAlwaysExpanded,
      b = _ref22.theme;
  return a ? "inherit" : b.sidebar.activeTextColor;
}, function (_ref23) {
  var a = _ref23.isAlwaysExpanded,
      b = _ref23.theme;
  return a ? "inherit" : b.sidebar.activeBgColor;
}, function (_ref24) {
  var a = _ref24.isDrilldown,
      b = _ref24.theme;
  return a && "\n    padding-top: " + 2 * b.sidebar.spacing.paddingVertical + "px;\n    padding-bottom: " + 2 * b.sidebar.spacing.paddingVertical + "px;\n    padding-left: " + b.sidebar.spacing.paddingHorizontal + "px;\n    &:hover {\n      color: currentColor;\n      background-color: " + b.sidebar.backgroundColor + ";\n    }\n  ";
});
export var ArrowWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  margin-right: ", "px;\n"])), function (_ref25) {
  var a = _ref25.theme;
  return a.sidebar.spacing.unit / 2;
});
export var StyledOperationBadge = styled(OperationBadge)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  flex-shrink: 0;\n  margin-top: 0;\n"])));
export var MenuLabel = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"])));
export var DrilldownMenu = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n  ", "\n  @keyframes slideIn {\n    0% {\n      transform: translateX(100%);\n    }\n    100% {\n      transform: translateX(0%);\n    }\n  }\n"])), function (_ref26) {
  var a = _ref26.theme;
  return "\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 100%;\n    z-index: 100;\n    background-color: " + a.sidebar.backgroundColor + ";\n    > div {\n      animation-name: slideIn;\n      animation-fill-mode: forwards;\n      animation-duration: 0.3s;\n      animation-timing-function: ease;\n      background-color: transparent;\n    }\n  ";
});
export var ButtonBack = styled.button(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  background-color: transparent;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: ", ";\n  transition: color 0.25s ease;\n  text-align: left;\n  margin-bottom: ", "px;\n  svg {\n    margin-right: ", "px;\n  }\n  &:hover {\n    color: ", ";\n  }\n"])), function (_ref27) {
  var a = _ref27.theme;
  return a.sidebar.textColorSecondary;
}, function (_ref28) {
  var a = _ref28.theme;
  return a.sidebar.fontSize;
}, function (_ref29) {
  var a = _ref29.theme;
  return 3 * a.sidebar.spacing.paddingVertical;
}, function (_ref30) {
  var a = _ref30.theme;
  return 1.5 * a.sidebar.spacing.unit;
}, function (_ref31) {
  var a = _ref31.theme;
  return a.sidebar.textColor;
});
export var StyledDrilldownMenuItem = styled.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  align-items: center;\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n"])), function (_ref32) {
  var a = _ref32.theme;
  return a.sidebar.textColor;
}, function (_ref33) {
  var a = _ref33.theme;
  return a.sidebar.fontSize;
}, function (_ref34) {
  var a = _ref34.theme;
  return a.typography.fontWeightBold;
});
export var DrilldownMenuWrapper = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n  padding: ", "px\n    ", "px;\n  margin-bottom: ", "px;\n  margin-left: ", "px;\n  word-break: break-word;\n"])), function (_ref35) {
  var a = _ref35.theme;
  return a.sidebar.spacing.paddingVertical;
}, function (_ref36) {
  var a = _ref36.theme;
  return a.sidebar.spacing.paddingHorizontal;
}, function (_ref37) {
  var a = _ref37.theme;
  return 3 * a.sidebar.spacing.unit;
}, function (_ref38) {
  var a = _ref38.theme;
  return 2 * a.sidebar.spacing.unit;
});
export var DrilldownMenuIcon = styled.img(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n  width: ", "px;\n  height: ", "px;\n  margin-right: ", "px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  overflow: hidden;\n"])), function (_ref39) {
  var a = _ref39.theme;
  return 4 * a.sidebar.spacing.unit;
}, function (_ref40) {
  var a = _ref40.theme;
  return 4 * a.sidebar.spacing.unit;
}, function (_ref41) {
  var a = _ref41.theme;
  return a.sidebar.spacing.unit;
});
export var DrilldownMenuSublabel = styled.span(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n  display: block;\n  margin-top: 2px;\n  color: ", ";\n  font-size: 0.85rem;\n  font-weight: ", ";\n"])), function (_ref42) {
  var a = _ref42.theme;
  return a.sidebar.textColorSecondary;
}, function (_ref43) {
  var a = _ref43.theme;
  return a.typography.fontWeightRegular;
});
export var VersionSwitcherWrapper = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid ", ";\n  padding: ", "px\n    ", "px;\n"])), function (_ref44) {
  var a = _ref44.theme;
  return a.sidebar.separatorLineColor;
}, function (_ref45) {
  var a = _ref45.theme;
  return 3 * a.sidebar.spacing.unit;
}, function (_ref46) {
  var a = _ref46.theme;
  return 2 * a.sidebar.spacing.unit;
});
export var MenuInnerWrapper = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  overflow-y: auto;\n  flex-grow: 1;\n  padding-top: ", "px;\n"])), function (_ref47) {
  var a = _ref47.theme;
  return a.sidebar.spacing.offsetTop;
});
export function DrilldownMenuItem(a) {
  var b = a.icon,
      c = a.label,
      d = a.sublabel;
  return /*#__PURE__*/React.createElement(StyledDrilldownMenuItem, null, b && /*#__PURE__*/React.createElement(DrilldownMenuIcon, {
    src: b,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, c, d && /*#__PURE__*/React.createElement(DrilldownMenuSublabel, null, d)));
}